import getExercisePropertyData from './getExercisePropertyData'

/**
 * Convert program properties data
 *
 * @param trainings
 * @returns {[]}
 */
export default function getProgramProperties(entry, t, type) {
  if (!entry || (!entry.trainings && !entry.userTrainingsAndTrainings)) return null
  const data = []

  if (type === 'programDetail') {
    data.duration = false

    const entryTrainings = entry?.trainings?.length ? entry?.trainings : entry?.userTrainingsAndTrainings

    data.ageCategories = entryTrainings?.length ? getProgramAgeCategories(entryTrainings) : false
    data.fieldSizeCategory = entryTrainings?.length ? getProgramFieldSizeCategory(entryTrainings) : false
    data.playersMinimum = entryTrainings?.length ? getProgramPlayersMinimum(entryTrainings) : false
    data.playersMaximum = entryTrainings?.length ? getProgramPlayersMaximium(entryTrainings) : false
    data.frequencyCount = entryTrainings?.length ? getProgramFrequencyCount(entry, t, entryTrainings) : false
  } else {
    data.duration = false
    data.fieldSizeCategory = entry.fieldSizeCategory ? entry.fieldSizeCategory : false
    data.ageCategories = entry.ageCategories ? entry.ageCategories : false
  }

  return getExercisePropertyData(data, t, type)
}

function getProgramAgeCategories(trainings) {
  const ageCategories = []

  for (const tKey in trainings) {
    for (const eKey in trainings[tKey].exercises) {
      trainings[tKey].exercises[eKey].ageCategories.forEach((ageGroup) => {
        ageCategories.push(ageGroup)
      })
    }
  }

  return Array.from(new Set(ageCategories.map(JSON.stringify))).map(JSON.parse)
}

function getProgramFieldSizeCategory(trainings) {
  let maxFieldSizeTrainingIndex = 0
  let maxFieldSizeExerciseIndex = 0
  let maxFieldSizeTrainingValue = 0
  let maxFieldSizeExerciseValue = 0

  for (const tKey in trainings) {
    for (const eKey in trainings[tKey].exercises) {
      const currentMaxFieldSizeValue =
        trainings[tKey]?.exercises[eKey]?.exerciseContent[0]?.fieldSizeCategory[0]?.fieldSizeValue
      if (currentMaxFieldSizeValue > maxFieldSizeExerciseValue) {
        maxFieldSizeExerciseValue = currentMaxFieldSizeValue
        maxFieldSizeExerciseIndex = eKey
      }
    }

    if (maxFieldSizeExerciseValue > maxFieldSizeTrainingValue) {
      maxFieldSizeTrainingValue = maxFieldSizeExerciseValue
      maxFieldSizeTrainingIndex = tKey
    }
  }

  if (!trainings[maxFieldSizeTrainingIndex]?.exercises[maxFieldSizeExerciseIndex]) return null

  return trainings[maxFieldSizeTrainingIndex].exercises[maxFieldSizeExerciseIndex].exerciseContent[0].fieldSizeCategory
}

function getProgramPlayersMinimum(trainings) {
  let minPlayerCountExerciseIndex = 0
  let minPlayerCountTrainingIndex = 0
  let minPlayerCountExerciseValue = 0
  let minPlayerCountTrainingValue = 0
  let playersMinimum = 0

  for (const tKey in trainings) {
    for (const eKey in trainings[tKey].exercises) {
      const currentMinPlayerCountExerciseValue = trainings[tKey]?.exercises[eKey]?.exerciseContent[0]?.playersMinimum
      if (currentMinPlayerCountExerciseValue > minPlayerCountExerciseValue) {
        minPlayerCountExerciseValue = currentMinPlayerCountExerciseValue
        minPlayerCountExerciseIndex = eKey
      }
    }

    if (minPlayerCountExerciseValue < minPlayerCountTrainingValue) {
      minPlayerCountTrainingValue = minPlayerCountExerciseValue
      minPlayerCountTrainingIndex = tKey
    }
  }

  if (!trainings[minPlayerCountTrainingIndex]?.exercises[minPlayerCountExerciseIndex]) return null

  playersMinimum =
    trainings[minPlayerCountTrainingIndex].exercises[minPlayerCountExerciseIndex].exerciseContent[0].playersMinimum
  return playersMinimum >= 1 ? playersMinimum : false
}

function getProgramPlayersMaximium(trainings) {
  let maxPlayerCountExerciseIndex = 0
  let maxPlayerCountTrainingIndex = 0
  let maxPlayerCountExerciseValue = 0
  let maxPlayerCountTrainingValue = 0
  let playersMaximum = 0

  for (const tKey in trainings) {
    for (const eKey in trainings[tKey].exercises) {
      const currentMaxPlayerCountExerciseValue = trainings[tKey]?.exercises[eKey]?.exerciseContent[0]?.playersMaximum
      if (currentMaxPlayerCountExerciseValue > maxPlayerCountExerciseValue) {
        maxPlayerCountExerciseValue = currentMaxPlayerCountExerciseValue
        maxPlayerCountExerciseIndex = eKey
      }
    }

    if (maxPlayerCountExerciseValue > maxPlayerCountTrainingValue) {
      maxPlayerCountTrainingValue = maxPlayerCountExerciseValue
      maxPlayerCountTrainingIndex = tKey
    }
  }

  if (!trainings[maxPlayerCountTrainingIndex]?.exercises[maxPlayerCountExerciseIndex]) return null

  playersMaximum =
    trainings[maxPlayerCountTrainingIndex].exercises[maxPlayerCountExerciseIndex].exerciseContent[0].playersMaximum
  return playersMaximum >= 1 ? playersMaximum : false
}

function getProgramFrequencyCount(entry, t, trainings) {
  let frequency = ''

  if (entry.timesPerWeekCategory) {
    const frequencyLabel = entry.timesPerWeekCategory[0].title
    if (!entry.timesPerWeekCategory[0].title) return false

    const frequencyCount = parseInt(frequencyLabel.charAt(0))
    const weekCount = trainings.length / frequencyCount
    const weekLabel = weekCount <= 1 ? t('PROPERTYBLOCK__WEEK') : t('PROPERTYBLOCK__WEEKS')
    const weekTotal = weekCount <= 1 ? 1 : Math.ceil(weekCount)

    frequency = `${weekTotal} ${weekLabel} - ${frequencyCount}${t('PROPERTYBLOCK__TIMESPERWEEK_ABBR')}`
  }

  return frequency
}
